import { render, staticRenderFns } from "./TabGridSeleccion.vue?vue&type=template&id=0a43ef8e&"
import script from "./TabGridSeleccion.vue?vue&type=script&lang=ts&"
export * from "./TabGridSeleccion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports